export default "__VITE_ASSET__7792d560__"